import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StationaryService } from '../../features/stationary/services/stationary.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-supplier-new',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
  ],
  templateUrl: './stationary-new.component.html',
  styleUrl: './stationary-new.component.scss',
})
export class StationaryNewComponent {
  newSupplierForm: FormGroup;
  loading: boolean = false;
  stationaryId: any = null;
  stationaryData: any;
  codeData: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private stationaryService: StationaryService,
    private route: Router,
    private router: ActivatedRoute
  ) {}

  ngOnInit() {
    this.initForm();
  
    this.router.paramMap.subscribe((params) => {
      this.stationaryId = params.get('id');
  
      if (this.stationaryId) {
        this.fetchStationaryById(Number(this.stationaryId));
      } else {
        this.getStationaryCode();
      }
    });
  }
  
  initForm() {
    this.newSupplierForm = this.fb.group({
      code: [
        { value: '', disabled: true },
        [Validators.required, Validators.maxLength(50)],
      ],
      name: ['', [Validators.required, Validators.maxLength(50)]],
      price: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(/^\d+(\.\d{1,2})?$/),
        ],
      ],
      stock: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(/^\d+$/),
        ],
      ],
    });
  }

  fetchStationaryById(id: any) {
    this.stationaryService.fetchSingleStationary(id).subscribe({
      next: (data) => {
        this.stationaryData = data;
        this.newSupplierForm.patchValue({
          code: this.stationaryData?.stationoryCode,
          name: this.stationaryData?.stationoryName,
          price: this.stationaryData?.price,
          stock: this.stationaryData?.stock,
        });
      },
      error: (error) => {
        console.error(error, 'Error');
      },
    });
  }

  async onSubmitsdd() {
    if (this.newSupplierForm.invalid) {
      this.newSupplierForm.markAllAsTouched();
      this.toastr.warning('Please fill all required fields');
      return;
    }

    const formData = this.newSupplierForm.value;
    console.log('Form Data:', formData);
  }

  onCancel() {
    this.newSupplierForm.reset();
    this.route.navigate(['/stationary-items']);
  }

  async onSubmit() {
    this.loading = true;

    if (this.newSupplierForm.invalid) {
      this.newSupplierForm.markAllAsTouched();
      this.loading = false;
      return;
    }
    // const formValue = this.newSupplierForm.value;
    const formValue = this.newSupplierForm.getRawValue();
    const createStationaryValue = {
      stationoryName: formValue?.name,
      stationoryCode: formValue?.code,
      price: Number(formValue?.price),
      stock: Number(formValue?.stock),
    };

    if (!this.stationaryId) {
      this.stationaryService.createStationary(createStationaryValue).subscribe({
        next: (data) => {
          this.loading = false;
          this.toastr.success('Stationary created successfully', 'Success');
          this.route.navigate(['/stationary-items']);
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error, 'Error');
        },
      });
    } else {
      const updateStationaryValue = {
        id: Number(this.stationaryId),
        ...createStationaryValue,
      };
      this.stationaryService.updateStationary(updateStationaryValue).subscribe({
        next: (data) => {
          this.loading = false;
          this.toastr.success('Stationary updated successfully', 'Success');
          this.route.navigate(['/stationary-items']);
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error, 'Error');
        },
      });
    }
  }

  getStationaryCode() {
    this.stationaryService.fetchStationaryCode().subscribe({
      next: (code) => {
        if (code) {
          this.newSupplierForm.patchValue({ code });
        }
      },
      error: (error) => {
        console.error('Error fetching stationary code:', error);
      },
    });
  }
}
